export default ".text-center i {\n  color: #f97a4a;\n  font-size: 80px;\n}\n\nh3 {\n  font-size: 25px;\n  margin-bottom: 40px;\n}";